const fontIcons = {
  success: 'icon-ok',
  warning: 'icon-exclamation',
  info: 'icon-info',
  error: 'icon-exclamation-triangle'
} as const

export const mapIconToClass = (value: keyof typeof fontIcons) =>
  fontIcons[value]
